import { Box, Button, Link } from "@chakra-ui/react";

function Resume() {
  return (
    <Box lineHeight={"80px"} margin={"auto"} textAlign={"center"}>
      <Box>
        <Box
          pb={{ base: "30px", md: "40px", lg: "100px" }}
          color={"#FFB6C1"}
          mt={20}
          textDecoration={"underline"}
          fontSize={{ base: "30px", md: "45px", lg: "60px" }}
        >
          Resume
        </Box>
      </Box>
      <Box pb={"40px"} fontSize={{ base: "20px", md: "30px", lg: "40px" }}>
        <h1>Click here to download Resume</h1>
      </Box>
      <Box
        borderRadius={"70px"}
        margin={"auto"}
        border={"10px solid #FFB6C1"}
        w={{ base: "200px", md: "260px", lg: "320px" }}
      >
        <Link  id="resume-link-1" href="https://drive.google.com/uc?export=download&id=1JtdLZiel62sPDZoK5rHsn1Nfpfy9A4kN">
          <Button
            id="resume-button-1"
            w={{ base: "180px", md: "240px", lg: "300px" }}
            mt={"50px"}
            display={"flex"}
            justifyContent={"center"}
            margin="auto"
            alignItems={"center"}
            backgroundColor={"white"}
            color={"black"}
            h={{ base: "60px", md: "80px", lg: "100px" }}
            borderRadius={"70px"}
            _hover={"none"}
          >
            Download
          </Button>
        </Link>
      </Box>
    </Box>
  );
}
export default Resume;
